<!-- ================首页-非遗文化馆====================-->
<template>
    <div class="full-screen-container">
        <home-head />
        <div class="home-container">
            <div class="museum-read-wrapper">
                <div class="museum-read-header">
                    <div class="museum-read-title-box">
                        <div class="museum-read-title">非遗文化馆</div>
                        <div class="museum-read-subtitle">触摸千年文脉 建立文化自信</div>
                    </div>
                    <div class="museum-read-back" @click="goBack">
                        <span class="back-arrow">←</span>
                        <span>返回首页</span>
                    </div>
                </div>

                <div class="museum-read-cards">
                    <div class="museum-read-card" v-for="(item, index) in resourceList" :key="index" @click="handleResource(item, index)">
                        <div class="card-info">
                            <div class="card-title">{{ item.itemName }}</div>
                            <div class="card-desc">{{ item.itemClassifyName }}</div>
                        </div>
                        <div class="card-btn">查看资源</div>
                    </div>
                </div>

                <div class="museum-read-banner">
                    <div class="banner-info">
                        <div class="banner-title">坊 · 非遗工坊</div>
                        <div class="banner-desc">非遗主题班会传承课程</div>
                    </div>
                    <div class="banner-actions">
                        <div class="banner-btn" @click="goOfflineActivity">查看线下活动</div>
                        <div class="banner-btn" @click="goBooking">预约专属研学</div>
                    </div>
                </div>
            </div>
        </div>
        <home-footer />
    </div>
</template>

<script>
import { humItemList } from "@/api/admin/humanityItem";
import homeHead from "@/components/common/homeHead.vue";
import homeFooter from "@/components/common/homeFooter.vue";
export default {
    components: {homeHead,homeFooter},
    name: "museumIntangible",
    data() {
        return {
            museumKey:'3',
            resourceList: []
        }
    },
    created() {
        this.queryHumItemList();
    },
    methods: {
        /* ===============数据查询===================== */
        queryHumItemList(){
            humItemList({museumKey:this.museumKey}).then(res => {
                if (res.data.code===1){
                    this.resourceList = res.data.data;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        goBack(){
            this.$router.push("/museum/home")
        },
        handleResource(item, index){
            this.$router.push({
                path: "/bymy/theme",
                query: { itemId: item.itemId, businessType: 3, collectType: index + 1 },
            });
        },
        goOfflineActivity(){
            this.$router.push("/museum/intangible/offline")
        },
        goBooking(){
            this.$router.push({
                path: "/edu/excursion",
                query: { campKey: '3' }
            })
        }
    },
}
</script>

<style>
.home-container{
    width: 100%;
    height: calc(100vh - 280px);
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0;
    box-sizing: border-box;
}
.museum-read-wrapper{
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
}
.museum-read-header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.museum-read-title-box{
    display: flex;
    flex-direction: column;
}
.museum-read-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 8px;
}
.museum-read-subtitle{
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}
.museum-read-back{
    height: 32px;
    line-height: 32px;
    padding: 0 26px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}
.museum-read-back:hover{
    background-color: #9a1b1b;
}
.back-arrow{
    margin-right: 6px;
    font-size: 16px;
}
.museum-read-cards{
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 20px;
}
.museum-read-card{
    flex: 1;
    height: 160px;
    background-color: #ffffff;
    border-left: 4px solid #b22222;
    border-radius: 4px;
    box-shadow: 0 3px 12px rgba(0,0,0,0.08);
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    transition: all 0.25s ease;
}
.museum-read-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
}
.card-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.card-desc{
    font-size: 13px;
    color: #6b7280;
    font-family: sans-serif;
    line-height: 1.5;
}
.card-btn{
    width: 100%;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}
.card-btn:hover{
    background-color: #9a1b1b;
}
.museum-read-banner{
    width: 100%;
    height: 110px;
    background-color: #ffffff;
    border: 1.5px solid #b22222;
    border-radius: 4px;
    box-shadow: 0 3px 12px rgba(0,0,0,0.06);
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.banner-title{
    font-size: 20px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 1px;
    margin-bottom: 10px;
}
.banner-desc{
    font-size: 13px;
    color: #6b7280;
    font-family: sans-serif;
}
.banner-actions{
    display: flex;
    gap: 16px;
}
.banner-btn{
    height: 38px;
    line-height: 38px;
    padding: 0 20px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}
.banner-btn:hover{
    background-color: #9a1b1b;
}
@media (max-width: 1280px) {
    .museum-read-wrapper { padding: 0 20px; }
    .museum-read-card { height: 160px; padding: 16px; }
    .museum-read-banner { height: 100px; padding: 0 24px; }
    .banner-title { font-size: 18px; }
    .card-title { font-size: 17px; }
}
@media (max-width: 1024px) {
    .museum-read-title { font-size: 22px; }
    .museum-read-card { height: 150px; padding: 14px; }
    .museum-read-banner { height: 90px; padding: 0 20px; }
    .banner-btn { padding: 0 16px; height: 34px; line-height: 34px; }
}
</style>
